import React from 'react';
import {
    withStyles,
    ListItem,
    ListItemText,
    Grid,
    Typography,
    ButtonBase,
    Snackbar,
} from '@material-ui/core';

import {
    withRouter,
} from "react-router-dom"

import MBack from '../view/MBack';
import AppUtils from '../../control/apputlis';
import Apis from '../../network/Apis';
import AppData from '../../model/AppData';


class FindPwdCfm extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            password: '',
            confimpassword: '',
            snackopened: false,
            message: '',
        }
    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'FindPwdCfm');
        window.prevLoadingJs();
    }

    componentWillUnmount() {
        this.backTimeOut && clearTimeout(this.backTimeOut);
    }


    onSubmit = async () => {
        const { password, confimpassword } = this.state;
        if (password == '' || password.length < 6) {
            this.setState({ message: '密码不能少于6位', snackopened: true });
            return;
        }
        if (confimpassword != password) {
            this.setState({ message: '两次输入密码不一致', snackopened: true });
            return;
        }

        let result = await Apis.encryptionUpdateUserPwd(AppData.me.customer_id, AppData.me.token, password, confimpassword);
        console.log('encryptionUpdateUserPwd', result);
        if (result.code == 200) {
            this.backTimeOut = setTimeout(() => {
                window.history.back();
            }, 1000);
        } else {
            this.setState({ message: result.msg, snackopened: true });
        }
    }

    render() {
        const { classes } = this.props;
        const { password, confimpassword, snackopened, message } = this.state;
        return (
            <MBack title='找回密码'>
                <Grid style={{ height: 16 }}></Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50, display: 'flex' }}>
                    <ListItemText primary={
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ color: '#0D0D0D', fontSize: 13 }}>设置密码</Typography>
                            <input
                                type='password'
                                className={classes.input}
                                placeholder='输入密码'
                                onChange={event => this.setState({ password: event.target.value })}
                                value={password}
                                maxLength={12} />
                        </Grid>
                    } />

                </ListItem>
                <Grid className={classes.divider}></Grid>
                <ListItem style={{ backgroundColor: '#fff', height: 50, display: 'flex' }}>
                    <ListItemText primary={
                        <Grid container direction='row' alignItems='center'>
                            <Typography style={{ color: '#0D0D0D', fontSize: 13 }}>确认密码</Typography>
                            <input
                                type='password'
                                className={classes.input}
                                placeholder='再次输入'
                                maxLength={12}
                                onChange={event => this.setState({ confimpassword: event.target.value })}
                                value={confimpassword}
                            />
                        </Grid>
                    } />
                </ListItem>
                <Grid className={classes.divider}></Grid>
                <Grid style={{ height: 25 }}></Grid>
                <Grid container justify='center' >
                    <ButtonBase
                        className={classes.logoutBtn}
                        onClick={() => this.onSubmit()}
                    >下一步</ButtonBase>
                </Grid>
                <Snackbar
                    anchorOrigin={{
                        vertical: 'top',
                        horizontal: 'center',
                    }}
                    open={snackopened}
                    onClose={() => this.setState({ snackopened: false })}
                    message={message}
                    autoHideDuration={3000}>
                </Snackbar>
            </MBack>
        );
    }
}

export default withRouter(withStyles((theme) => ({
    logoutBtn: {
        backgroundColor: theme.palette.primary.main,
        borderRadius: 22.5,
        color: 'white',
        height: 45,
        width: "80%",
        margin: theme.spacing(5, 0, 2, 0),
        fontSize: 14,
        fontWeight: theme.typography.fontWeightBold,
    },
    divider: {
        height: 1,
        padding: theme.spacing(0, 1.5, 0, 1.5),
        backgroundColor: '#F0F0F0',
    },
    input: {
        outline: 'none',
        border: 0,
        flex: 1,
        marginLeft: 16,
        marginRight: 16,
        fontSize: 14,
    }

}))(FindPwdCfm));